import styled from '@emotion/styled'

type InputBaseProps = {
	children: React.ReactNode
} & React.HTMLAttributes<HTMLDivElement>

const InputBase = ({ children, ...rest }: InputBaseProps) => {
	return <Block {...rest}>{children}</Block>
}

const Block = styled.div`
	display: flex;
	flex-direction: column;
`

export default InputBase
